import axios from 'axios'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {getWDHeadersURL,getWDFooterURL} from '../../constants/index'


const initialState = {
    loading: false,
    error: false,
    headerHTML: '',
    footerHTML: ''
    
}

export const fetchHeader = createAsyncThunk('common/fetchHeader', () => {
    return axios
      .get(getWDHeadersURL)
      .then(response => response.data)
  })
export const fetchFooter = createAsyncThunk('common/fetchFooter', () => {
    return axios
      .get(getWDFooterURL)
      .then(response => response.data)
  })
  

const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        
        resetAlerts: (state) => {
            state.success = '';
            state.error = '';
        }
    },
    extraReducers: builder => {
        builder.addCase(fetchHeader.pending, state => {
            state.loading = true
          })
          builder.addCase(fetchHeader.fulfilled, (state, action) => {
            state.loading = false
            const parser = new DOMParser();
            const doc = parser.parseFromString(action.payload, 'text/html');
            
            // state.headerHTML = doc
            state.headerHTML = action.payload
            state.error = ''
          })
          builder.addCase(fetchHeader.rejected, (state, action) => {
            state.loading = false
            state.users = []
            state.error = action.error.message
          })
        builder.addCase(fetchFooter.pending, state => {
            state.loading = true
          })
          builder.addCase(fetchFooter.fulfilled, (state, action) => {
            state.loading = false
            const parser = new DOMParser();
            const doc = parser.parseFromString(action.payload, 'text/html');
            
            // state.headerHTML = doc
            state.footerHTML = action.payload
            state.error = ''
          })
          builder.addCase(fetchFooter.rejected, (state, action) => {
            state.loading = false
            state.users = []
            state.error = action.error.message
          })
    }
})

export const { resetAlerts } = commonSlice.actions
export default commonSlice.reducer
